import React, { useState } from "react";
import ShippingDetails from "./ShippingDetails";
import "./shipping.css";
import { ImCross } from "react-icons/im";
import { toast } from "react-toastify";

const ShippingAddress = ({
  totalPrice,
  totalItem,
  isProceedToPay,
  setIsProceedToPay,
  shippingDetails,
  setShippingDetails,
  toggleRun,
  setBal,
  setIsComplete,
}) => {
  const [isShippingAddressFullFil, setIsShippingAddressFullfil] =
    useState(false);
  const { name, country, city, road, mobile, house, postalCode } =
    shippingDetails;

  const onChangeInputsAddress = (e) => {
    const { name, value } = e.target;
    setShippingDetails((previous) => {
      return { ...previous, [name]: value };
    });
  };
  const OnSubmitFormAddress = (e) => {
    e.preventDefault();
    if (
      name !== "" &&
      country !== "" &&
      city !== "" &&
      road !== "" &&
      mobile !== "" &&
      postalCode !== ""
    ) {
      localStorage.setItem("shippingAddress", JSON.stringify(shippingDetails));
      setIsShippingAddressFullfil(true);
    } else {
      toast.warn("Please fill the  shipping address inputs!", {
        position: "top-center",
        autoClose: 1500,
      });
    }
  };
  return (
    <section>
      <div
        className={`shipping_pay_confirm_section ${
          isProceedToPay && "show-shipping_pay_confirm_section"
        } ${isShippingAddressFullFil && "hide-address-confirm"}`}
      >
        <div className="shipping_form_container">
          <div className="form_titles_close_btn_flex">
            <h3>Please Fill Your Shipping Address</h3>
            <ImCross
              onClick={() => setIsProceedToPay(false)}
              className="cross_shipping_Form"
            />
          </div>
          <form onSubmit={OnSubmitFormAddress}>
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              name="name"
              value={name}
              onChange={onChangeInputsAddress}
              placeholder="enter your name*"
              className="shipping_input"
            />
            <label htmlFor="mobile">Mobile</label>
            <input
              type="text"
              name="mobile"
              value={mobile}
              onChange={onChangeInputsAddress}
              placeholder="Your phone number*"
              className="shipping_input"
            />
            <label htmlFor="country">Country:</label>
            <input
              type="text"
              name="country"
              value={country}
              onChange={onChangeInputsAddress}
              placeholder="your country name*"
              className="shipping_input"
            />
            <label htmlFor="city">City:</label>
            <input
              type="text"
              name="city"
              value={city}
              onChange={onChangeInputsAddress}
              placeholder="your city name*"
              className="shipping_input"
            />
            <label htmlFor="road">Road:</label>
            <input
              type="text"
              name="road"
              value={road}
              onChange={onChangeInputsAddress}
              placeholder="your area road address*"
              className="shipping_input"
            />
            <label htmlFor="houseno">House Holding No:</label>
            <input
              type="text"
              name="house"
              value={house}
              onChange={onChangeInputsAddress}
              placeholder="house holding no.(not mendatory) "
              className="shipping_input"
            />
            <label htmlFor="postalcode">Postal Code:</label>
            <input
              type="text"
              name="postalCode"
              value={postalCode}
              onChange={onChangeInputsAddress}
              placeholder="your local postal code*"
              className="shipping_input"
            />
            <button type="submit" className="ProccedToPay_btn">
              Confirm
            </button>
          </form>
        </div>
      </div>
      <ShippingDetails
        toggleRun={toggleRun}
        setBal={setBal}
        totalPrice={totalPrice}
        setIsComplete={setIsComplete}
        isShippingAddressFullFil={isShippingAddressFullFil}
        setIsProceedToPay={setIsProceedToPay}
        setIsShippingAddressFullfil={setIsShippingAddressFullfil}
        shippingDetails={shippingDetails}
      />
    </section>
  );
};

export default ShippingAddress;
